import { render } from "./Button.vue?vue&type=template&id=27e0a4df&scoped=true&ts=true"
import script from "./Button.vue?vue&type=script&setup=true&lang=ts"
export * from "./Button.vue?vue&type=script&setup=true&lang=ts"

import "./Button.vue?vue&type=style&index=0&id=27e0a4df&scoped=true&lang=css"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e0a4df"],['__file',"resources/js/components/ui/button/Button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27e0a4df"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27e0a4df', __exports__)) {
    console.log('reload')
    api.reload('27e0a4df', __exports__)
  }
  
  module.hot.accept("./Button.vue?vue&type=template&id=27e0a4df&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('27e0a4df', render)
  })

}


export default __exports__